import React, { useState, useRef, useEffect } from 'react';
import './settings.scss';
import { Button, Card, Input, Modal, Form, Spin } from 'antd';
import { fetchData } from '../../../Services/FetchData';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';
import rightArrow from '../../../assets/images/right_arrow_gray.png'
import bottomArrow from '../../../assets/images/bottom_arrow.png'
import { Popup_Toast } from '../../../constants/Popups_Toast';
import { PlaceholderContent } from '../../../constants/Placeholder';
import { toast } from 'react-toastify';

const Settings = () => {
    document.title = "Settings";
    let placeholderContent = PlaceholderContent?.CHANGE_PHONE_NUMBER;
    const [changePhoneModal, setChangePhoneModal] = useState(false);
    const [otpModal, setOtpModal] = useState(false);
    const [form] = Form.useForm();
    const [otpForm] = Form.useForm();
    const maxLength = 6;
    const [timer, setTimer] = useState(0);
    const [isInputDisabled, setIsInputDisabled] = useState(false);
    const [resendOtpCount, setResendOtpCount] = useState(0);
    const resentButton = useRef(null);
    const [changeNumberPayLoad, setChangeNumberPayload] = useState();
    const [changeNumberButton, setChangeNumberButton] = useState(true)
    const [logoutModal, setLogoutModal] = useState(false);
    const [isOtpValid, setIsOtpValid] = useState(true);
    const [loading, setLoading] = useState(false);
    const [changeMobileOtpButtonDisable, setChangeMobileOtpButtonDisable] = useState(true);
    const [newNumber, setNewNumber] = useState();
    // temporary
    const [otp, setOtp] = useState();
    let popupContent = Popup_Toast?.LOGOUT_CONFIRMATION;
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setIsOtpValid(false); // Set OTP as invalid when timer reaches 0
            setIsInputDisabled(true); // Disable the input field when timer runs out
            // resentButton.current.classList.add('active');
        }
    }, [timer]);

    const logOut = () => {
        localStorage.setItem('isVerified', false);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userDetails');
        window.location.href = '/login';
    };

    const changePhone = () => {
        setChangePhoneModal(true);
    };

    const handleCancel = () => {
        setChangeNumberButton(true)
        form.resetFields();
        setChangePhoneModal(false);
        setOtpModal(false);
        otpForm.resetFields(); 
        // Reset OTP form fields
        setTimer(30); // Reset timer
        setIsInputDisabled(false); // Re-enable the OTP input field
        setIsOtpValid(true); // Reset OTP validity
    };

    const onFinish = async (values) => {
        try {
            setLoading(true)
            setChangePhoneModal(false);
            form.resetFields();
            otpForm.resetFields(); 
            let endpoint = API_ENDPOINTS.UPDATE_PHONE.UPDATE;
            let payload = {
                phone: values.phone,
                country_code: '+91'
            };
            const response = await fetchData(endpoint, payload);
            if (response) {
                setLoading(false)
                setChangeNumberPayload(payload)
                // temporary
                console.log('response otp', response.otp)
                setOtp(String(response.otp))
                setOtpModal(true);

                setTimer(30);
                setIsInputDisabled(false); // Ensure the input is enabled
                setIsOtpValid(true); // Reset OTP validity state
            }
        } catch (error) {
            setLoading(false)
            console.log('An error occurred while updating the mobile number. Please try again.');
        }
    };

    const onFinishOtp = async (value) => {
        try {
            // if (otp !== value.otp) {
            //     setIsOtpValid(false); // Mark OTP as invalid if it doesn't match
            // } else {
            //     console.log('otp given' , otp)
            //     setChangeNumberPayload((prev) => ({
            //         ...prev,
            //         otp: otp
            //     }));
            // }
            setLoading(true)
            setChangeNumberPayload((prev) => ({
                ...prev,
                otp: otp
            }));
        } catch (error) {
            setLoading(false)
            alert('An error occurred while updating the OTP.');
        }
    };
    useEffect(() => {
        console.log('otp', otp)
    }, [otp])
    const validateOTP = (_, value) => {
        if (value && value.length === maxLength) {
            return Promise.resolve();
        } else {
            return Promise.reject('Enter OTP.');
        }
    };

    const onChangeOtp = (e) => {
        let inputValue = e.target.value;
        if (inputValue.length === maxLength) {
            setChangeMobileOtpButtonDisable(false)
        }
        else {
            setChangeMobileOtpButtonDisable(true)
        }
    };

    const handlePhoneChange = (e) => {
        if (e.target.value.length === 10) {
            setNewNumber(e.target.value)
            setChangeNumberButton(false)
        }
        else {
            setChangeNumberButton(true)
        }

    };

    useEffect(() => {
        const verifyOtp = async () => {

            if (changeNumberPayLoad?.otp) {
                const endpoint = API_ENDPOINTS.UPDATE_PHONE.UPDATE_VERIFY_OTP;

                try {
                    setLoading(true)
                    const response = await fetchData(endpoint, changeNumberPayLoad);

                    if (response?.user) {
                        // setChangeMobileSuccess(true)
                        toast.success(' Phone number changed successfully.', {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                            className: 'custom_toast'
                        });
                        setLoading(false)
                        const userDetails = JSON.parse(localStorage.getItem('userDetails')) || {};
                        userDetails.phone = changeNumberPayLoad.phone;
                        localStorage.setItem('userDetails', JSON.stringify(userDetails));
                        // window.location.reload();
                        setOtpModal(false)
                    }
                } catch (error) {
                    setLoading(false)
                    // setChangeMobileSuccess(false)

                    console.error('Error during OTP verification:', error);
                    // Optionally, you can show an alert or notification here
                }
            }
        };

        verifyOtp();
    }, [changeNumberPayLoad]);

    // useEffect(() => {
    //     if (timer > 0) {
    //         const interval = setInterval(() => {
    //             setTimer(prevTimer => prevTimer - 1);
    //         }, 1000);
    //         return () => clearInterval(interval);
    //     } else {
    //         setIsOtpValid(false); // Set OTP as invalid when timer reaches 0
    //         setIsInputDisabled(true); // Disable the input field when timer runs out
    //         FormData.setFormVerified({
    //             ...FormData.formVerified,
    //             [FormData.page]: false
    //         });

    //         resentButton.current.classList.add('active');
    //     }
    // }, [timer])


    return (
        <>
            {
                loading && (
                    <div className="spinner center">
                        <Spin />
                    </div>
                )
            }
            <div className="settings_wrap">
                <Card className='listing '>
                    <Button type="link" className='dflt_btn_removed text_dark ' onClick={changePhone}>
                        <div className="flex_wrap">
                            <div className="left">
                                <h4 className='text_red text_md'>Change Mobile Number</h4>
                                <p className='mb-0 text_sm'>Update your contact information by changing your phone number.</p>
                            </div>
                            <figure className="right">
                                <img src={rightArrow} alt="" />
                            </figure>
                        </div>
                    </Button>
                </Card>
                <Card style={{ marginTop: "24px" }}>
                    <Button type="link" className='dflt_btn_removed text_dark' onClick={() => {
                        setLogoutModal(true)
                    }}>
                        <div className="flex_wrap">
                            <div className="left">
                                <h4 className='text_red text_md'>{popupContent?.content?.title}</h4>
                                <p className='mb-0 text_sm'>Log out and return to the login page.</p>
                            </div>
                            <figure className="right">
                                <img src={rightArrow} alt="" />
                            </figure>
                        </div>
                    </Button>
                </Card>
            </div>
            <Modal afterClose={() => (document.body.style.overflow = 'initial')} className='sm_modal work_modal center_modal' open={logoutModal} footer={[
                <div className='text-center'>
                    <Button key="submit" type="text" className='short  custom_btn' onClick={() => {
                        setLogoutModal(false)
                    }}>
                        Close
                    </Button>
                    <Button key="submit" type="primary" className='short wide ' onClick={() => {
                        logOut()
                    }}>
                        Continue
                    </Button>
                </div>
            ]} onCancel={() => {
                setLogoutModal(false)
            }}>
                <div className="modal_cnt">
                    <h2 className="text_lg text_red">Log Out</h2>
                    <p className="md">
                        {popupContent?.content?.description}
                    </p>
                </div>
            </Modal>
            {/* <Modal afterClose={() => (document.body.style.overflow = 'initial')} className='sm_modal work_modal text-center' open={changeMobileSuccess} footer={[
                <div className='text-center'>
                    <Button key="submit" type="primary" className='short sm' onClick={() => {
                        setChangeMobileSuccess(false)
                    }}>
                        Ok
                    </Button>
                </div>,
            ]} onCancel={() => {
                setChangeMobileSuccess(false)
            }}>
                Mobile Number changed successfully.
            </Modal> */}
            <Modal
                className='sm_modal change_phone_modal center_modal'
                open={changePhoneModal}
                onOk={() => form.submit()} // Triggers form submission
                onCancel={handleCancel}
                footer={
                    <div className='text-center button_wrapper'>
                        <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                            Close
                        </Button>

                        <Button
                            className='md wide'
                            disabled={changeNumberButton}
                            key="submit"
                            type="primary"
                            onClick={() => form.submit()} // Submit form when button is clicked
                        >
                            Continue
                        </Button>
                    </div>
                }
            >
                <Form
                    id="changePhoneForm"
                    form={form}
                    onFinish={onFinish}
                >
                    <div className="wrap">
                        <h2 className='text_lg text_red text-center' style={{ marginBottom: '.7em' }}>
                            Change Mobile Number
                        </h2>
                        <p className='md'>Enter your new mobile number below. An OTP will be sent to verify this number.</p>
                        <Form.Item
                            className='change_phone mb-0'
                            name="phone"
                            rules={[{ required: true, message: 'Please enter the phone number!' }]}
                        >
                            <div className="wrap">
                                <div className="input_field input_wrap">
                                    <span className='plus_symbol'>+</span>
                                    <input
                                        placeholder="Enter country code"
                                        type="text"
                                        value={+91}
                                        disabled={true}
                                        className='country_code  bg_transparent'
                                        maxLength={2}
                                        onKeyDown={(e) => {
                                            if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {/* <span className='bottom_arrow'><img src={bottomArrow} className='icon' alt="" /></span> */}
                                </div>
                                <Input
                                    classNames={'demo_field'}
                                    placeholder={placeholderContent?.ChangePhoneNumber}
                                    type="text"
                                    onChange={handlePhoneChange}
                                    className='input_field'
                                    maxLength={10}
                                    onKeyDown={(e) => {
                                        if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                        </Form.Item>
                    </div>

                </Form>
            </Modal>
            <Modal
                afterClose={() => (document.body.style.overflow = 'initial')}
                className='sm_modal otp_modal center_modal'
                open={otpModal}
                footer={
                    <div className='text_center flex_center change_number_footer'>
                        <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                            Close
                        </Button>
                        <Button type='primary' className='md wide' onClick={() => {
                            onFinishOtp()
                        }} disabled={changeMobileOtpButtonDisable}>Verify</Button>
                    </div>
                }
                onOk={() => onFinishOtp}
                onCancel={handleCancel}
            >
                <Form
                    form={otpForm}
                    onFinish={onFinishOtp}
                >
                    <h2 className='text_lg text-center text_red' style={{ marginBottom: '.7em' }}>Verify New Mobile Number</h2>
                    <p className='md'>Please enter the 6 digit OTP that we sent to +91 {newNumber}</p>
                    <div style={{ maxWidth: '509px', margin: 'auto', paddingTop: '1em', paddingBottom: '1em' }}>
                        <Form.Item
                            name='otp'
                            className='mb-0'
                            rules={[
                                // { required: true, message: 'Enter OTP.' },
                                { validator: validateOTP }
                            ]}
                        >
                            <Input
                                className='input_field'
                                maxLength={6}
                                onChange={onChangeOtp}
                                style={{
                                    margin: '10px auto',
                                    color: '#9E9E9E',
                                    textAlign: 'center',
                                    boxShadow: 'none',
                                    outline: 'none',
                                    height: 'calc(1vw + 38px)'
                                }}
                                type='text'
                                placeholder='- - - - - -'
                                disabled={isInputDisabled}
                                onKeyDown={(e) => {
                                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                        <div className="otp_cnt" style={{ marginTop: ' 15px' }}>
                            <span className='d-block text_red md' style={{ marginBottom: '20px' }}>
                                Expect OTP in <strong>{timer}s</strong>
                            </span>
                            {/* <Button
                                ref={resentButton}
                                className='resend_btn wide'
                                style={{ fontSize: '16px', borderRadius: "20px" }}
                                type='secondary'
                                disabled={timer !== 0}
                                onClick={() => {
                                    setResendOtpCount(prev => prev + 1);
                                    setIsInputDisabled(false);
                                    setTimer(60); // Reset the timer
                                    otpForm.resetFields(); // Clear OTP input field
                                }}
                            >
                                Resend OTP
                            </Button> */}
                        </div>
                    </div>
                </Form>
            </Modal>
        </>
    );
};

export default Settings;
